import { Component, Input, OnInit, inject } from '@angular/core';
import { isEqual } from 'lodash';
import { Form } from '../../data/form';
import { AdUser, UserService } from '@rbb/ng-web-template-lib';
import { ApproverType, getLocalizedNameOfApproverType } from '../../types/approver-type';
import { ActionType } from '../../types/action-type';
import { OrgUnitType } from '../../types/org-unit-type';

@Component({
  selector: 'app-form-diff',
  templateUrl: './form-diff.component.html',
  styleUrl: './form-diff.component.css',
  standalone: true
})
export class FormDiffComponent implements OnInit {
  private userService = inject(UserService);

  @Input() form: Form | undefined;
  @Input() oldForm: Form | undefined;

  owners: AdUser[] | undefined;
  operators: AdUser[] | undefined;
  readers: AdUser[] | undefined;
  tester: AdUser[] | undefined;

  ngOnInit(): void {
    if (this.form?.owners) {
      this.userService.getAdUsers(this.form?.owners).subscribe(data => this.owners = data);
    }
    if (this.form?.operators) {
      this.userService.getAdUsers(this.form?.operators).subscribe(data => this.operators = data);
    }
    if (this.form?.readers) {
      this.userService.getAdUsers(this.form?.readers).subscribe(data => this.readers = data);
    }
    if (this.form?.tester) {
      this.userService.getAdUsers(this.form?.tester).subscribe(data => this.tester = data);
    }
  }

  userListToString(users: AdUser[] | undefined): string {
    return users?.length ? users.map(s => s.firstName + ' ' + s.lastName).join(', ') : '--';
  }

  protected readonly isEqual = isEqual;
  protected readonly ApproverType = ApproverType;
  protected readonly getLocalizedNameOfApproverType = getLocalizedNameOfApproverType;
  protected readonly ActionType = ActionType;
  protected readonly OrgUnitType = OrgUnitType;
}
